{
  "name": "sharp",
  "description": "High performance Node.js image processing, the fastest module to resize JPEG, PNG, WebP, GIF, AVIF and TIFF images",
  "version": "0.32.6",
  "author": "Lovell Fuller <npm@lovell.info>",
  "homepage": "https://github.com/lovell/sharp",
  "contributors": [
    "Pierre Inglebert <pierre.inglebert@gmail.com>",
    "Jonathan Ong <jonathanrichardong@gmail.com>",
    "Chanon Sajjamanochai <chanon.s@gmail.com>",
    "Juliano Julio <julianojulio@gmail.com>",
    "Daniel Gasienica <daniel@gasienica.ch>",
    "Julian Walker <julian@fiftythree.com>",
    "Amit Pitaru <pitaru.amit@gmail.com>",
    "Brandon Aaron <hello.brandon@aaron.sh>",
    "Andreas Lind <andreas@one.com>",
    "Maurus Cuelenaere <mcuelenaere@gmail.com>",
    "Linus Unnebäck <linus@folkdatorn.se>",
    "Victor Mateevitsi <mvictoras@gmail.com>",
    "Alaric Holloway <alaric.holloway@gmail.com>",
    "Bernhard K. Weisshuhn <bkw@codingforce.com>",
    "Chris Riley <criley@primedia.com>",
    "David Carley <dacarley@gmail.com>",
    "John Tobin <john@limelightmobileinc.com>",
    "Kenton Gray <kentongray@gmail.com>",
    "Felix Bünemann <Felix.Buenemann@gmail.com>",
    "Samy Al Zahrani <samyalzahrany@gmail.com>",
    "Chintan Thakkar <lemnisk8@gmail.com>",
    "F. Orlando Galashan <frulo@gmx.de>",
    "Kleis Auke Wolthuizen <info@kleisauke.nl>",
    "Matt Hirsch <mhirsch@media.mit.edu>",
    "Matthias Thoemmes <thoemmes@gmail.com>",
    "Patrick Paskaris <patrick@paskaris.gr>",
    "Jérémy Lal <kapouer@melix.org>",
    "Rahul Nanwani <r.nanwani@gmail.com>",
    "Alice Monday <alice0meta@gmail.com>",
    "Kristo Jorgenson <kristo.jorgenson@gmail.com>",
    "YvesBos <yves_bos@outlook.com>",
    "Guy Maliar <guy@tailorbrands.com>",
    "Nicolas Coden <nicolas@ncoden.fr>",
    "Matt Parrish <matt.r.parrish@gmail.com>",
    "Marcel Bretschneider <marcel.bretschneider@gmail.com>",
    "Matthew McEachen <matthew+github@mceachen.org>",
    "Jarda Kotěšovec <jarda.kotesovec@gmail.com>",
    "Kenric D'Souza <kenric.dsouza@gmail.com>",
    "Oleh Aleinyk <oleg.aleynik@gmail.com>",
    "Marcel Bretschneider <marcel.bretschneider@gmail.com>",
    "Andrea Bianco <andrea.bianco@unibas.ch>",
    "Rik Heywood <rik@rik.org>",
    "Thomas Parisot <hi@oncletom.io>",
    "Nathan Graves <nathanrgraves+github@gmail.com>",
    "Tom Lokhorst <tom@lokhorst.eu>",
    "Espen Hovlandsdal <espen@hovlandsdal.com>",
    "Sylvain Dumont <sylvain.dumont35@gmail.com>",
    "Alun Davies <alun.owain.davies@googlemail.com>",
    "Aidan Hoolachan <ajhoolachan21@gmail.com>",
    "Axel Eirola <axel.eirola@iki.fi>",
    "Freezy <freezy@xbmc.org>",
    "Daiz <taneli.vatanen@gmail.com>",
    "Julian Aubourg <j@ubourg.net>",
    "Keith Belovay <keith@picthrive.com>",
    "Michael B. Klein <mbklein@gmail.com>",
    "Jordan Prudhomme <jordan@raboland.fr>",
    "Ilya Ovdin <iovdin@gmail.com>",
    "Andargor <andargor@yahoo.com>",
    "Paul Neave <paul.neave@gmail.com>",
    "Brendan Kennedy <brenwken@gmail.com>",
    "Brychan Bennett-Odlum <git@brychan.io>",
    "Edward Silverton <e.silverton@gmail.com>",
    "Roman Malieiev <aromaleev@gmail.com>",
    "Tomas Szabo <tomas.szabo@deftomat.com>",
    "Robert O'Rourke <robert@o-rourke.org>",
    "Guillermo Alfonso Varela Chouciño <guillevch@gmail.com>",
    "Christian Flintrup <chr@gigahost.dk>",
    "Manan Jadhav <manan@motionden.com>",
    "Leon Radley <leon@radley.se>",
    "alza54 <alza54@thiocod.in>",
    "Jacob Smith <jacob@frende.me>",
    "Michael Nutt <michael@nutt.im>",
    "Brad Parham <baparham@gmail.com>",
    "Taneli Vatanen <taneli.vatanen@gmail.com>",
    "Joris Dugué <zaruike10@gmail.com>",
    "Chris Banks <christopher.bradley.banks@gmail.com>",
    "Ompal Singh <ompal.hitm09@gmail.com>",
    "Brodan <christopher.hranj@gmail.com",
    "Ankur Parihar <ankur.github@gmail.com>",
    "Brahim Ait elhaj <brahima@gmail.com>",
    "Mart Jansink <m.jansink@gmail.com>",
    "Lachlan Newman <lachnewman007@gmail.com>"
  ],
  "scripts": {
    "install": "(node install/libvips && node install/dll-copy && prebuild-install) || (node install/can-compile && node-gyp rebuild && node install/dll-copy)",
    "clean": "rm -rf node_modules/ build/ vendor/ .nyc_output/ coverage/ test/fixtures/output.*",
    "test": "npm run test-lint && npm run test-unit && npm run test-licensing && npm run test-types",
    "test-lint": "semistandard && cpplint",
    "test-unit": "nyc --reporter=lcov --reporter=text --check-coverage --branches=100 mocha",
    "test-licensing": "license-checker --production --summary --onlyAllow=\"Apache-2.0;BSD;ISC;MIT\"",
    "test-leak": "./test/leak/leak.sh",
    "test-types": "tsd",
    "docs-build": "node docs/build && node docs/search-index/build",
    "docs-serve": "cd docs && npx serve",
    "docs-publish": "cd docs && npx firebase-tools deploy --project pixelplumbing --only hosting:pixelplumbing-sharp"
  },
  "main": "lib/index.js",
  "types": "lib/index.d.ts",
  "files": [
    "binding.gyp",
    "install/**",
    "lib/**",
    "src/**"
  ],
  "repository": {
    "type": "git",
    "url": "git://github.com/lovell/sharp"
  },
  "keywords": [
    "jpeg",
    "png",
    "webp",
    "avif",
    "tiff",
    "gif",
    "svg",
    "jp2",
    "dzi",
    "image",
    "resize",
    "thumbnail",
    "crop",
    "embed",
    "libvips",
    "vips"
  ],
  "dependencies": {
    "color": "^4.2.3",
    "detect-libc": "^2.0.2",
    "node-addon-api": "^6.1.0",
    "prebuild-install": "^7.1.1",
    "semver": "^7.5.4",
    "simple-get": "^4.0.1",
    "tar-fs": "^3.0.4",
    "tunnel-agent": "^0.6.0"
  },
  "devDependencies": {
    "@types/node": "*",
    "async": "^3.2.4",
    "cc": "^3.0.1",
    "exif-reader": "^1.2.0",
    "extract-zip": "^2.0.1",
    "icc": "^3.0.0",
    "jsdoc-to-markdown": "^8.0.0",
    "license-checker": "^25.0.1",
    "mocha": "^10.2.0",
    "mock-fs": "^5.2.0",
    "nyc": "^15.1.0",
    "prebuild": "^12.0.0",
    "semistandard": "^16.0.1",
    "tsd": "^0.29.0"
  },
  "license": "Apache-2.0",
  "config": {
    "libvips": "8.14.5",
    "integrity": {
      "darwin-arm64v8": "sha512-1QZzICfCJd4wAO0P6qmYI5e5VFMt9iCE4QgefI8VMMbdSzjIXA9L/ARN6pkMQPZ3h20Y9RtJ2W1skgCsvCIccw==",
      "darwin-x64": "sha512-sMIKMYXsdU9FlIfztj6Kt/SfHlhlDpP0Ups7ftVFqwjaszmYmpI9y/d/q3mLb4jrzuSiSUEislSWCwBnW7MPTw==",
      "linux-arm64v8": "sha512-CD8owELzkDumaom+O3jJ8fKamILAQdj+//KK/VNcHK3sngUcFpdjx36C8okwbux9sml/T7GTB/gzpvReDrAejQ==",
      "linux-armv6": "sha512-wk6IPHatDFVWKJy7lI1TJezHGHPQut1wF2bwx256KlZwXUQU3fcVcMpV1zxXjgLFewHq2+uhyMkoSGBPahWzlA==",
      "linux-armv7": "sha512-HEZC9KYtkmBK5rUR2MqBhrVarnQVZ/TwLUeLkKq0XuoM2pc/eXI6N0Fh5NGEFwdXI2XE8g1ySf+OYS6DDi+xCQ==",
      "linux-x64": "sha512-SlFWrITSW5XVUkaFPQOySAaSGXnhkGJCj8X2wGYYta9hk5piZldQyMp4zwy0z6UeRu1qKTKtZvmq28W3Gnh9xA==",
      "linuxmusl-arm64v8": "sha512-ga9iX7WUva3sG/VsKkOD318InLlCfPIztvzCZKZ2/+izQXRbQi8VoXWMHgEN4KHACv45FTl7mJ/8CRqUzhS8wQ==",
      "linuxmusl-x64": "sha512-yeaHnpfee1hrZLok2l4eFceHzlfq8gN3QOu0R4Mh8iMK5O5vAUu97bdtxeZZeJJvHw8tfh2/msGi0qysxKN8bw==",
      "win32-arm64v8": "sha512-kR91hy9w1+GEXK56hLh51+hBCBo7T+ijM4Slkmvb/2PsYZySq5H7s61n99iDYl6kTJP2y9sW5Xcvm3uuXDaDgg==",
      "win32-ia32": "sha512-HrnofEbzHNpHJ0vVnjsTj5yfgVdcqdWshXuwFO2zc8xlEjA83BvXZ0lVj9MxPxkxJ2ta+/UlLr+CFzc5bOceMw==",
      "win32-x64": "sha512-BwKckinJZ0Fu/EcunqiLPwOLEBWp4xf8GV7nvmVuKKz5f6B+GxoA2k9aa2wueqv4r4RJVgV/aWXZWFKOIjre/Q=="
    },
    "runtime": "napi",
    "target": 7
  },
  "engines": {
    "node": ">=14.15.0"
  },
  "funding": {
    "url": "https://opencollective.com/libvips"
  },
  "binary": {
    "napi_versions": [
      7
    ]
  },
  "semistandard": {
    "env": [
      "mocha"
    ]
  },
  "cc": {
    "linelength": "120",
    "filter": [
      "build/include"
    ]
  },
  "tsd": {
    "directory": "test/types/"
  }
}
